export async function getServiceWorkerRegistrations() {
  if ('serviceWorker' in navigator) {
    try {
      const registrations = await navigator.serviceWorker.getRegistrations();
      console.log('Service Worker registrations:', registrations);
      return registrations;
    } catch (error) {
      console.error('Failed to get service worker registration:', error);
      return null;
    }
  } else {
    console.warn('Service workers are not supported in this browser.');
    return null;
  }
}

export async function registerServiceWorker() {
  const sw = await navigator.serviceWorker.register('/sw.js');
  let refreshing = false;

  const activateWaitingWorker = () => {
    if (sw.waiting) {
      sw.waiting.postMessage({ type: 'SKIP_WAITING' });
    }
  };

  activateWaitingWorker();
  sw.addEventListener('updatefound', () => {
    const installingWorker = sw.installing;
    installingWorker?.addEventListener('statechange', () => {
      if (
        installingWorker.state === 'installed' &&
        navigator.serviceWorker.controller
      ) {
        activateWaitingWorker();
      }
    });
  });
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!refreshing) {
      refreshing = true;
      window.location.reload();
    }
  });
  console.log('Service Worker registered');
  return sw;
}

export async function unregisterServiceWorker() {
  const registrations = await navigator.serviceWorker.getRegistrations();
  for (const registration of registrations) {
    await registration.unregister();
  }
  console.log('Service Worker unregistered');
}

export async function getSubscription(sw) {
  let subscription = await sw.pushManager.getSubscription();
  if (!subscription) {
    return null;
  }
  console.log('Existing Push Subscription found');
  return subscription.toJSON();
}

export async function createSubscription(sw, vapidPublicKey) {
  const subscription = await sw.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(vapidPublicKey),
  });
  console.log('Push Subscription created');
  return subscription.toJSON();
}

export function getMobileUUID() {
  let uuid = localStorage.getItem('uuid');
  if (!uuid) {
    uuid = crypto.randomUUID();
    localStorage.setItem('uuid', uuid);
  }
  return uuid;
}

export function setMobileUUID(uuid) {
  localStorage.setItem('uuid', uuid);
}

export function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = atob(base64);
  return Uint8Array.from([...rawData].map((c) => c.charCodeAt(0)));
}

export function isIOS() {
  return (
    ['iPad', 'iPhone', 'iPod'].includes(navigator.platform) ||
    // iPadOS 13+
    (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
  );
}

export function isPWA() {
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true
  );
}
